/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {Injectable} from '@angular/core';

let /** @type {?} */ _nextRequestId = 0;
export const /** @type {?} */ JSONP_HOME = '__ng_jsonp__';
let /** @type {?} */ _jsonpConnections: {[key: string]: any} = null;
/**
 * @return {?}
 */
function _getJsonpConnections(): {[key: string]: any} {
  const /** @type {?} */ w: {[key: string]: any} = typeof window == 'object' ? window : {};
  if (_jsonpConnections === null) {
    _jsonpConnections = w[JSONP_HOME] = {};
  }
  return _jsonpConnections;
}
export class BrowserJsonp {
/**
 * @param {?} url
 * @return {?}
 */
build(url: string): any {
    const /** @type {?} */ node = document.createElement('script');
    node.src = url;
    return node;
  }
/**
 * @return {?}
 */
nextRequestID(): string { return `__req${_nextRequestId++}`; }
/**
 * @param {?} id
 * @return {?}
 */
requestCallback(id: string): string { return `${JSONP_HOME}.${id}.finished`; }
/**
 * @param {?} id
 * @param {?} connection
 * @return {?}
 */
exposeConnection(id: string, connection: any) {
    const /** @type {?} */ connections = _getJsonpConnections();
    connections[id] = connection;
  }
/**
 * @param {?} id
 * @return {?}
 */
removeConnection(id: string) {
    const /** @type {?} */ connections = _getJsonpConnections();
    connections[id] = null;
  }
/**
 * @param {?} node
 * @return {?}
 */
send(node: any) { document.body.appendChild( /** @type {?} */((<Node>(node)))); }
/**
 * @param {?} node
 * @return {?}
 */
cleanup(node: any) {
    if (node.parentNode) {
      node.parentNode.removeChild( /** @type {?} */((<Node>(node))));
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BrowserJsonp_tsickle_Closure_declarations() {
/** @type {?} */
BrowserJsonp.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BrowserJsonp.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
